import { render, staticRenderFns } from "./LEDForm.vue?vue&type=template&id=2fd7e37c&scoped=true&"
import script from "./LEDForm.vue?vue&type=script&lang=js&"
export * from "./LEDForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd7e37c",
  null
  
)

export default component.exports